import { render } from "./settings-change-password.vue?vue&type=template&id=1c40104c"
import script from "./settings-change-password.vue?vue&type=script&lang=js"
export * from "./settings-change-password.vue?vue&type=script&lang=js"

import "./settings-change-password.vue?vue&type=style&index=0&id=1c40104c&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__